export default __webpack_public_path__ + "static/media/sad.7433cbd2.jpg";